import React, { useRef, useEffect, useState } from "react";
import { forwardRef } from "react";
import "../styles/Sponsors.css";
import SponsorImage from "../assets/sponsors_reveal.png";
import Ubuy_presents from "../assets/sponsors_img/Ubuy_HD_logo.jpg"
import Provis_copowered from "../assets/sponsors_img/provis_tech_logo.png"
import kankriya_sponsor from "../assets/sponsors_img/kankriya_img.jpg"
import bob_sponsor from "../assets/sponsors_img/bob_img.png"
import xyz_sponsor from "../assets/sponsors_img/xyz-logo-white.png"

const Sponsors = forwardRef((props, ref) => {
  // const marqueeRef = useRef(null);
  // const [isPaused, setIsPaused] = useState(false);
  // let isDragging = false;
  // let startX, scrollLeft;

  // useEffect(() => {
  //   const marquee = marqueeRef.current;

  //   const handleMouseDown = (e) => {
  //     isDragging = true;
  //     startX = e.pageX - marquee.offsetLeft;
  //     scrollLeft = marquee.scrollLeft;
  //     marquee.style.cursor = "grabbing";
  //     setIsPaused(true);
  //   };

  //   const handleMouseLeave = () => {
  //     isDragging = false;
  //     marquee.style.cursor = "grab";
  //     setIsPaused(false);
  //   };

  //   const handleMouseUp = () => {
  //     isDragging = false;
  //     marquee.style.cursor = "grab";
  //     setIsPaused(false);
  //   };

  //   const handleMouseMove = (e) => {
  //     if (!isDragging) return;
  //     e.preventDefault();
  //     const x = e.pageX - marquee.offsetLeft;
  //     const walk = (x - startX) * 2; // Adjust speed
  //     marquee.scrollLeft = scrollLeft - walk;
  //   };

  //   const handleTouchStart = (e) => {
  //     isDragging = true;
  //     startX = e.touches[0].pageX - marquee.offsetLeft;
  //     scrollLeft = marquee.scrollLeft;
  //     setIsPaused(true);
  //   };

  //   const handleTouchMove = (e) => {
  //     if (!isDragging) return;
  //     const x = e.touches[0].pageX - marquee.offsetLeft;
  //     const walk = (x - startX) * 2;
  //     marquee.scrollLeft = scrollLeft - walk;
  //   };

  //   const handleTouchEnd = () => {
  //     isDragging = false;
  //     setIsPaused(false);
  //   };

  //   const handleMouseEnter = () => {
  //     setIsPaused(true);
  //   };

  //   const handleMouseOut = () => {
  //     setIsPaused(false);
  //   };

  //   // Add event listeners
  //   marquee.addEventListener("mousedown", handleMouseDown);
  //   marquee.addEventListener("mouseleave", handleMouseLeave);
  //   marquee.addEventListener("mouseup", handleMouseUp);
  //   marquee.addEventListener("mousemove", handleMouseMove);
  //   marquee.addEventListener("touchstart", handleTouchStart);
  //   marquee.addEventListener("touchmove", handleTouchMove);
  //   marquee.addEventListener("touchend", handleTouchEnd);
  //   marquee.addEventListener("mouseenter", handleMouseEnter);
  //   marquee.addEventListener("mouseout", handleMouseOut);

  //   return () => {
  //     // Remove event listeners on cleanup
  //     marquee.removeEventListener("mousedown", handleMouseDown);
  //     marquee.removeEventListener("mouseleave", handleMouseLeave);
  //     marquee.removeEventListener("mouseup", handleMouseUp);
  //     marquee.removeEventListener("mousemove", handleMouseMove);
  //     marquee.removeEventListener("touchstart", handleTouchStart);
  //     marquee.removeEventListener("touchmove", handleTouchMove);
  //     marquee.removeEventListener("touchend", handleTouchEnd);
  //     marquee.removeEventListener("mouseenter", handleMouseEnter);
  //     marquee.removeEventListener("mouseout", handleMouseOut);
  //   };
  // }, []);

  return (
    <section ref={ref} className="sponsors">
      <h1>Powered BY</h1>
      <div className="wrapper">
          <div className="content">
              <span className="stat1">
                <img className="title_sponsor_card" src={Ubuy_presents} alt="Sponsor" />
              </span>
          </div>
      </div>

      <h1>Co-Powered BY</h1>
      <div className="wrapper">
          <div className="content">
              <span className="stat1">
                <img className="title_sponsor_card1" src={Provis_copowered} alt="Sponsor" />
              </span>
          </div>
      </div>
      
      <h1>Other Sponsors</h1>
      <div className="wrapper">
          <div className="content1">
              <span className="stat1">
                <img className="title_sponsor_card10" src={kankriya_sponsor} alt="Sponsor" />
              </span>
              <span className="stat1">
                <img className="title_sponsor_card10" src={bob_sponsor} alt="Sponsor" />
              </span>
              <span className="stat1">
                <img className="title_sponsor_card10" src={xyz_sponsor} alt="Sponsor" />
              </span>
          </div>
      </div>
      
{/* 
      <h1>Other Sponsors</h1>
      <div className="marquee-wrapper">
        <div className={`marquee ${isPaused ? "paused" : ""}`} ref={marqueeRef}>
          <div className="marquee-content">
            {[...Array(8)].map((_, index) => (
              <span key={index} className="stat">
                <img className="sponsor_card" src={SponsorImage} alt="Sponsor" />
              </span>
            ))}
          </div>
        </div>
      <div className="fade fade-left"></div>
      <div className="fade fade-right"></div>
      </div> */}
    </section>
  );
});

export default Sponsors;
